/* eslint-disable max-len */
import { createGlobalStyle } from "styled-components";
import { palette, font } from "styled-theme";
import {
  BASE_COLORS,
  FONT_WEIGHT,
  FONT_SIZE_PX,
  FONT_FAMILY,
} from "config/theme/constants";

const GlobalStyles = createGlobalStyle`
  body{
    font-family: "Poppins" !important;
  }
  th, td {
    white-space: break-spaces !important;
  }
  .ant-btn{
    border-radius: 4px;
    font-family: "Poppins" !important;
  }
  .ant-radio-checked .ant-radio-inner {
    background-color: ${BASE_COLORS.curiousBlue}!important;
    border-color: ${BASE_COLORS.curiousBlue}!important;
  }
  .ant-radio-wrapper .ant-radio-disabled .ant-radio-inner {
    background-color: rgba(0, 0, 0, 0.04) !important;
    border-color: ${BASE_COLORS.altoDark} !important;
  }
  .header {
    display: flex;
    justify-content: space-between;
    color: red;
  }
  
.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  display: flex;
  align-items: center;
}
  .logo {
    font-size: ${FONT_SIZE_PX.FONT32};
    font-weight: ${FONT_WEIGHT.bold};
    color: ${BASE_COLORS.white};
  }

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: ${BASE_COLORS.alabaster} !important;
  }

  .ant-row.ant-form-item {
    margin-bottom: 5px;
  }

  .has-success.has-feedback {
    .ant-select {
      .ant-select-selection {
        .ant-select-selection__rendered {
          .ant-select-selection__placeholder {
            display: none !important;
          }
        }
      }
    }
  }


  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: ${BASE_COLORS.alabaster} !important;
}

font-family: ${font("primary", 0)};

h1,
h2,
h3,
h4,
h5,
h6,
a,
p,
li,
input,
textarea,
span,
div,
img,
svg {
  &::selection {
    background: ${palette("primary", 0)};
    color: ${BASE_COLORS.white};
  }
}

.ant-row:not(.ant-form-item) {
  &:before,
  &:after {
    display: none;
  }
}

.ant-row > div {
  padding: 0;
}

.isoLeftRightComponent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.isoCenterComponent {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
/********** Add Your Global CSS Here **********/

body {
  -webkit-overflow-scrolling: touch;
}

html h1,
html h2,
html h3,
html h4,
html h5,
html h6,
html a,
html p,
html li,
input,
textarea,
span,
div,
html,
body,
html a {
  margin-bottom: 0;
  font-family: ${FONT_FAMILY.main} !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
}

html ul {
  -webkit-padding-start: 0px;
  list-style: none;
  margin-bottom: 0;
}

.scrollbar-track-y,
.scrollbar-thumb-y {
  width: 5px !important;
}

.scrollbar-track-x,
.scrollbar-thumb-x {
  height: 5px !important;
}

.scrollbar-thumb {
  border-radius: 0 !important;
}

.scrollbar-track {
  background: rgba(222, 222, 222, 0.15) !important;
}

.scrollbar-thumb {
  border-radius: 0 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow:after,
.ant-popover-placement-bottomLeft
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-bottomRight
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow:after,
.ant-popover-placement-topLeft
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-topRight
  > .ant-popover-content
  > .ant-popover-arrow:after {
  left: 0;
  margin-left: -4px;
}

/********** Add Your Global RTL CSS Here **********/

/* Popover */

html[dir='rtl'] .ant-popover {
  text-align: right;
}

/* Ecommerce Card */

html[dir='rtl'] .isoCardInfoForm .ant-input {
  text-align: right;
}

/* Modal */

html[dir='rtl'] .has-success.has-feedback:after,
html[dir='rtl'] .has-warning.has-feedback:after,
html[dir='rtl'] .has-error.has-feedback:after,
html[dir='rtl'] .is-validating.has-feedback:after {
  left: 0;
  right: auto;
}

html[dir='rtl'] .ant-modal-close {
  right: inherit;
  left: 0;
}

html[dir='rtl'] .ant-modal-footer {
  text-align: left;
}

html[dir='rtl'] .ant-modal-footer button + button {
  margin-left: 0;
  margin-right: 8px;
}

html[dir='rtl'] .ant-confirm-body .ant-confirm-content {
  margin-right: 42px;
}

html[dir='rtl'] .ant-btn > .anticon + span,
html[dir='rtl'] .ant-btn > span + .anticon {
  margin-right: 0.5em;
}

html[dir='rtl'] .ant-btn-loading span {
  margin-left: 0;
  margin-right: 0.5em;
}

html[dir='rtl']
  .ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline) {
  padding-left: 25px;
  padding-right: 29px;
}

html[dir='rtl']
  .ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline)
  .anticon {
  margin-right: -14px;
  margin-left: 0;
}

/* Confirm */

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-body > .anticon {
  margin-left: 16px;
  margin-right: 0;
  float: right;
}

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-btns {
  float: left;
}

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-btns button + button {
  margin-right: 10px;
  margin-left: 0;
}

/* Message */

html[dir='rtl'] .ant-message .anticon {
  margin-left: 8px;
  margin-right: 0;
}

/* Pop Confirm */

html[dir='rtl'] .ant-popover-message-title {
  padding-right: 20px;
  padding-left: 0;
}

html[dir='rtl'] .ant-popover-buttons {
  text-align: left;
}

/* Notification */

html[dir='rtl']
  .ant-notification-notice-closable
  .ant-notification-notice-message {
  padding-left: 24px;
  padding-right: 0;
}

html[dir='rtl']
  .ant-notification-notice-with-icon
  .ant-notification-notice-message,
html[dir='rtl']
  .ant-notification-notice-with-icon
  .ant-notification-notice-description {
  margin-right: 48px;
}

html[dir='rtl'] .ant-notification-notice-close {
  right: auto;
  left: 16px;
}

html[dir='rtl'] .ant-notification-notice-with-icon {
  left: 0;
}

/* Dropzone */

html[dir='rtl'] .dz-hidden-input {
  display: none;
}

.ant-layout,
.ant-col {
  font-family: ${FONT_FAMILY.main};
}

.ant-input,
.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  font-family: ${FONT_FAMILY.main};
  font-size: 13px;
}

.ant-switch.ant-switch-checked {
  background: ${BASE_COLORS.downRiver};
}

.ant-switch.ant-switch-checked:hover:not(.ant-switch-disabled) {
  background: ${BASE_COLORS.downRiver};
}

.map-indicator .ant-image .ant-image-img {
  height: 20px !important;
}

.map-indicator .ant-btn-default:disabled {
  color: rgba(0, 0, 0, 0.88) !important;
  cursor: default;
}

.track-shipment-map .ant-radio-button-wrapper:hover {
  color: rgba(0, 0, 0, 0.88) !important;
}

.track-shipment-map .ant-radio-button-wrapper-checked,
.track-shipment-map .ant-radio-button-wrapper-checked:hover {
  color: ${BASE_COLORS.white} !important;
}

.track-shipment-map .infoDiv {
  width: 310px;
  overflow: hidden;
  font-family: ${FONT_FAMILY.main};
  font-size: ${FONT_SIZE_PX.xxs};
}

.track-shipment-map .innerpopup {
  width: 100%;
  height: auto;
  max-height: 1000px;
  overflow-y: auto;
  clear: both;
}

.track-shipment-map .popup_left1 {
  float: left;
  width: 147px;
  text-align: right;
  padding-right: 3px;
  font-size: ${FONT_SIZE_PX.xxs};
}

.track-shipment-map .popup_right1 {
  float: left;
  width: 158px;
  font-size: ${FONT_SIZE_PX.xxs};
  text-align: left;
}

.track-shipment-map .popup_left2 {
  width: 147px;
  text-align: right;
  padding-right: 3px;
  font-size: ${FONT_SIZE_PX.xxs};
  float: left;
}

.track-shipment-map .popup_left3 {
  float: left;
  width: 147px;
  text-align: right;
  padding-right: 3px;
  font-size: ${FONT_SIZE_PX.xxs};
}

.track-shipment-map .popup_right3 {
  float: left;
  width: 158px;
  font-size: ${FONT_SIZE_PX.xxs};
  text-align: left;
}

.track-shipment-map .history-title {
  font-size: ${FONT_SIZE_PX.xl};
  font-weight: ${FONT_WEIGHT.normal};
  font-family: ${FONT_FAMILY.main};
  color: ${BASE_COLORS.downRiver};
  opacity: 1;
  margin-bottom: 5px;
}

.track-shipment-map .content-container {
  padding-left: 10px;
  padding-bottom: 10px;
  padding-top: 5px;
  width: 100%;
}

.ant-form-item {
  margin-bottom: 15px;
  font-family: ${FONT_FAMILY.main};
}

.ant-menu {
  margin-left: 2px;
  margin-right: 2px;
}

.ant-menu .ant-menu-submenu-title {
  border-radius: 2px;
}

.ant-menu-submenu-popup .ant-menu-vertical .ant-menu-item {
  font-size: ${FONT_SIZE_PX.xxs};
  font-family: ${FONT_FAMILY.main};
  height: 30px;
  line-height: 25px;
}

.ant-checkbox-checked .ant-checkbox-inner {
  background-color: ${BASE_COLORS.denim} !important;
  border-color: ${BASE_COLORS.denim} !important;
  width: 15px;
  height: 15px;
}

[class^="ant-col"],
.ant-input {
  font-size: ${FONT_SIZE_PX.xs};
}

.ant-btn-primary,
.ant-btn-primary:disabled,
.ant-btn-primary:hover {
  background-color: ${BASE_COLORS.downRiver};
  color: ${BASE_COLORS.white};
}

.ant-btn-primary:not(:disabled):not(.ant-btn-disabled):hover {
  background-color: ${BASE_COLORS.downRiver};
}

.ant-tabs .ant-tabs-tab-btn {
  opacity: 60%;
  font-size: ${FONT_SIZE_PX.xs};
}

.ant-tabs .ant-tabs-tab-btn:hover {
  opacity: 100%;
  font-size: ${FONT_SIZE_PX.xs};
}

.ant-divider {
  border-block-start: 1px solid ${BASE_COLORS.altolight} !important;
}

.ant-input:hover,
.ant-input:focus {
  border-color: ${BASE_COLORS.denim};
}

.sop-with-buttons .ant-input {
  padding: 5px 11px !important;
}

.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: ${BASE_COLORS.curiousBlue};
  opacity: 100%;
}

.ant-tabs .ant-tabs-tab:hover {
  color: ${BASE_COLORS.curiousBlue};
}

.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover .ant-select-selector {
  border-color: ${BASE_COLORS.denim};
}

.ant-tabs .ant-tabs-ink-bar {
  background: ${BASE_COLORS.curiousBlue};
}

.ant-menu-submenu-popup .ant-menu-vertical .ant-menu-item:hover {
  background: ${BASE_COLORS.solitude} !important;
}

.selected-sub-menu {
  background: ${BASE_COLORS.solitude} !important;
}

.ant-menu-light.ant-menu-root.ant-menu-vertical {
  border-inline-end: ${BASE_COLORS.transparent} !important;
}

.ant-form-item .ant-form-item-label {
  padding: 0 !important;
}

.ant-form-item .ant-form-item-label >label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {
  display: inline-block;
  margin-inline-end: 4px;
  color: ${BASE_COLORS.sunsetOrange};
  font-size: ${FONT_SIZE_PX.md};
  font-family: ${FONT_FAMILY.main};
  line-height: 1;
  content: "*";
  visibility: visible;
}

.ant-form-item .ant-form-item-label >label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
  display: none;
}

.table-action .ant-popover-content .ant-popover-inner {
  padding: 0 8px 8px 8px;
  font-size: ${FONT_SIZE_PX.xs};
}

.ant-modal-header {
  border-bottom: 1.5px solid rgba(5,5,5,.06);
  margin-bottom: 0px;
}

.ant-picker .ant-picker-suffix {
  color: ${BASE_COLORS.downRiver} !important;
}

.add-activity-modal {
  .ant-modal-content {
    padding: 10px;
    height: 73vh;
    width: 700px;
    overflow: hidden;
    @media screen and (max-width: 1024px) {
      height: 63vh;
        }
      }

  .ant-modal-body {
    max-height: 100vh - 10vh;
  }
  .ant-form {
    margin-bottom: 20px;
  }

  .ant-modal-close {
    top: "18px";
  }

  .ant-modal-header {
    border-bottom: 1.5px solid rgba(5,5,5,.06);
    margin-bottom: 0px;
  }

  .ant-modal-title {
    line-height: 2;
    padding-bottom: 15px;
  }

  .ant-form-item {
    margin-bottom: 10px;
  }

  .ant-form-item-label>label {
    min-width: 115px;
    justify-content: "flex-end";
    margin-right: 5px;
  }

  .ant-tooltip {
    display: none;
  }

  .ant-modal-body {
    font-size: ${FONT_SIZE_PX.xs};
    line-height: 1;
  }

  .ant-modal-footer {
    margin-top: 0 !important;
  }

  .ant-form {
    font-family: ${FONT_FAMILY.main};
  }

  [class*=" ant-row"] {
    font-family: ${FONT_FAMILY.main};
    font-size: ${FONT_SIZE_PX.xs};
  }
  .radioGroupInput{
    .ant-radio-checked .ant-radio-inner{
      background-color: ${BASE_COLORS.curiousBlue} !important;
      border-color: ${BASE_COLORS.curiousBlue} !important;
    }
  }
  .checkboxColorClass{
    .ant-checkbox-checked .ant-checkbox-inner{
      background-color: ${BASE_COLORS.curiousBlue} !important;
      border-color: ${BASE_COLORS.curiousBlue} !important;
    }
  }
  .ant-switch-checked{
    background-color: ${BASE_COLORS.curiousBlue} !important;
    font-size: 13px !important;
  }
}
.add-excel-modal {
  .ant-modal-content {
    padding: 10px 10px 20px 10px;
    max-height: 100vh - 10vh;
    overflow-x: hidden;
    overflow-y: hidden;
    width: 1000px;
    min-height:87vh;

  @media screen and (max-width: 950px) {
            width: 90vw;
        }
        
        @media screen and (max-width: 768px) {
            width: 95vw;
        }
        
        /* For mobile screens */
        @media screen and (max-width: 480px) {
            width: 98vw;
        }
      }
  .ant-modal-body {
    max-height: 100vh - 10vh;
  }
  .ant-form {
    margin-bottom: 20px;
  }

  .ant-modal-close {
    top: "18px";
  }

  .ant-modal-header {
    border-bottom: 1.5px solid rgba(5,5,5,.06);
    margin-bottom: 0px;
  }

  .ant-modal-title {
    line-height: 2;
    padding-bottom: 15px;
  }

  .ant-form-item {
    margin-bottom: 10px;
  }

  .ant-form-item-label>label {
    min-width: 115px;
    justify-content: "flex-end";
    margin-right: 5px;
  }

  .ant-tooltip {
    display: none;
  }

  .ant-modal-footer {
    margin-top: 0 !important;
  }

  .ant-form {
    font-family: ${FONT_FAMILY.main};
  }

  [class*=" ant-row"] {
    font-family: ${FONT_FAMILY.main};
    font-size: ${FONT_SIZE_PX.xs};
  }
  .radioGroupInput{
    .ant-radio-checked .ant-radio-inner{
      background-color: ${BASE_COLORS.curiousBlue} !important;
      border-color: ${BASE_COLORS.curiousBlue} !important;
    }
  }
  .checkboxColorClass{
    .ant-checkbox-checked .ant-checkbox-inner{
      background-color: ${BASE_COLORS.curiousBlue} !important;
      border-color: ${BASE_COLORS.curiousBlue} !important;
    }
  }
  .ant-switch-checked{
    background-color: ${BASE_COLORS.curiousBlue} !important;
    font-size: 13px !important;
  }
}
.add-pdf-modal {
    padding-top:5px;
  .ant-modal-content {
    padding: 10px 10px 20px 10px;
    max-height: 100vh - 10vh;
    overflow-x: hidden;
    overflow-y: hidden;
    width: 1100px;
    min-height:72vh;

  @media screen and (max-width: 950px) {
            width: 90vw;
        }
        
        @media screen and (max-width: 768px) {
            width: 95vw;
        }
        
        /* For mobile screens */
        @media screen and (max-width: 480px) {
            width: 98vw;
        }
      }
  .ant-modal-body {
    max-height: 100vh - 10vh;
  }
  .ant-form {
    margin-bottom: 20px;
  }

  .ant-modal-close {
    top: "18px";
  }

  .ant-modal-header {
    border-bottom: 1.5px solid rgba(5,5,5,.06);
    margin-bottom: 0px;
  }

  .ant-modal-title {
    line-height: 2;
    padding-bottom: 15px;
  }

  .ant-form-item {
    margin-bottom: 10px;
  }

  .ant-form-item-label>label {
    min-width: 115px;
    justify-content: "flex-end";
    margin-right: 5px;
  }

  .ant-tooltip {
    display: none;
  }

  .ant-modal-footer {
    margin-top: 0 !important;
  }

  .ant-form {
    font-family: ${FONT_FAMILY.main};
  }

  [class*=" ant-row"] {
    font-family: ${FONT_FAMILY.main};
    font-size: ${FONT_SIZE_PX.xs};
  }
  .radioGroupInput{
    .ant-radio-checked .ant-radio-inner{
      background-color: ${BASE_COLORS.curiousBlue} !important;
      border-color: ${BASE_COLORS.curiousBlue} !important;
    }
  }
  .checkboxColorClass{
    .ant-checkbox-checked .ant-checkbox-inner{
      background-color: ${BASE_COLORS.curiousBlue} !important;
      border-color: ${BASE_COLORS.curiousBlue} !important;
    }
  }
  .ant-switch-checked{
    background-color: ${BASE_COLORS.curiousBlue} !important;
    font-size: 13px !important;
  }
}
.add-customer-modal {
  .ant-modal-content {
    padding: 10px;
    height:500px;
    overflow: auto;
    /* overflow-y: hidden;
    width: 1000px; */
  }

  .ant-modal-body {
    max-height: 100vh - 10vh;
  }
  .ant-form {
    margin-bottom: 20px;
  }

  .ant-modal-close {
    top: "18px";
  }

  .ant-modal-header {
  
    border-bottom: 1.5px solid rgba(5,5,5,.06);
    margin-bottom: 0px;
  }

  .ant-modal-title {
    line-height: 2;
    padding-bottom: 15px;
  }

  .ant-form-item {
    margin-bottom: 10px;
  }

  .ant-form-item-label>label {
    min-width: 115px;
    justify-content: "flex-end";
    margin-right: 5px;
  }

  .ant-tooltip {
    display: none;
  }

  .ant-modal-footer {
    margin-top: 0 !important;
  }

  .ant-form {
    font-family: ${FONT_FAMILY.main};
  }

  [class*=" ant-row"] {
    font-family: ${FONT_FAMILY.main};
    font-size: ${FONT_SIZE_PX.xs};
  }
  .radioGroupInput{
    .ant-radio-checked .ant-radio-inner{
      background-color: ${BASE_COLORS.curiousBlue} !important;
      border-color: ${BASE_COLORS.curiousBlue} !important;
    }
  }
  .checkboxColorClass{
    .ant-checkbox-checked .ant-checkbox-inner{
      background-color: ${BASE_COLORS.curiousBlue} !important;
      border-color: ${BASE_COLORS.curiousBlue} !important;
    }
  }
  .ant-switch-checked{
    background-color: ${BASE_COLORS.curiousBlue} !important;
    font-size: 13px !important;
  }
}
.add-piaggio-customer-modal {
  .ant-modal-content {
    padding: 10px;
    height: 70vh; /* Use viewport height instead of fixed pixels */
    min-height: 550px; /* Minimum height to ensure form visibility */
    max-height: 90vh; /* Maximum height to prevent overflow */
    overflow: auto;
  }
  
  .ant-modal-body {
    max-height: calc(70vh - 120px); /* Account for header and footer */
    overflow-y: auto; /* Enable scrolling if content exceeds height */
    padding: 15px 0; /* Add some vertical padding */
  }
  
  .ant-form {
    margin-bottom: 20px;
    height: 100%; /* Take full available height */
  }
  
  .ant-modal-close {
    top: 18px; /* Remove quotes around value */
  }
  
  .ant-modal-header {
    border-bottom: 1.5px solid rgba(5,5,5,.06);
    margin-bottom: 0px;
    padding: 16px 24px; /* Consistent padding */
  }
  
  .ant-modal-title {
    line-height: 2;
    padding-bottom: 15px;
  }
  
  .ant-form-item {
    margin-bottom: 16px; /* Slightly increased spacing */
  }
  
  .ant-form-item-label > label {
    min-width: 115px;
    justify-content: flex-end; /* Remove quotes */
    margin-right: 5px;
  }
  
  .ant-tooltip {
    display: none;
  }
  
  .ant-modal-footer {
    margin-top: 0 !important;
    padding: 10px 24px 24px; /* Consistent padding */
  }
  
  .ant-form {
    font-family: ${FONT_FAMILY.main};
  }
  
  [class*=" ant-row"] {
    font-family: ${FONT_FAMILY.main};
    font-size: ${FONT_SIZE_PX.xs};
  }
  
  .radioGroupInput {
    .ant-radio-checked .ant-radio-inner {
      background-color: ${BASE_COLORS.curiousBlue} !important;
      border-color: ${BASE_COLORS.curiousBlue} !important;
    }
  }
  
  .checkboxColorClass {
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${BASE_COLORS.curiousBlue} !important;
      border-color: ${BASE_COLORS.curiousBlue} !important;
    }
  }
  
  .ant-switch-checked {
    background-color: ${BASE_COLORS.curiousBlue} !important;
    font-size: 13px !important;
  }
}

/* Alternative: If you want to keep the modal centered while increasing height */
.add-customer-modal.ant-modal {
  top: 5vh; /* Reduce top spacing to 5% of viewport height */
}

/* Or for even less top gap: */
.add-customer-modal.ant-modal {
  top: 50px; /* Fixed top margin */
}

/* Alternative: If you want to keep the modal centered while increasing height */
.add-customer-modal.ant-modal {
  top: 5vh; /* Reduce top spacing to 5% of viewport height */
}

/* Or for even less top gap: */
.add-customer-modal.ant-modal {
  top: 50px; /* Fixed top margin */
}
.confirmation-modal-wrapper{
  .ant-btn{
    min-width: 100px !important;
    font-size: ${FONT_SIZE_PX.xs} !important;
  }
}

.add-account-modal {
  width: 600px !important;
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type=number] {
    -moz-appearance: textfield;
  }
  .ant-modal-body {
    max-height: calc(100vh - 240px);
    overflow: auto;
  }
  .ant-form {
    overflow: auto;
    margin-bottom: 20px;
  }
  .ant-form-item-label>label{
    max-width: "150px";
    white-space: normal;
    width:  "150px";
    line-height: 24px;
    height: auto;
    align-items: center;
  }
  .visibility-hidden-item-col{
    display: "flex";
    p{
      margin-top: 0;
    }
  }
  .visibility-hidden-item{
    visibility: hidden;
    min-width: 150px;
  }
}

.ant-collapse-item .ant-collapse-header-collapsible-only .ant-collapse-header-text {
  width: 100%;
}

.ant-select-dropdown .ant-select-item {
  font-size: ${FONT_SIZE_PX.xs};
}

.ant-select-dropdown .ant-select-item-option-content {
  display: contents !important;
  white-space: unset !important;
  text-overflow: unset !important;
}

.ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
  background: ${BASE_COLORS.curiousBlue} !important;
}

.ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
  border: 1px solid ${BASE_COLORS.curiousBlue} !important
}

.ant-picker-dropdown .ant-picker-today-btn {
  color: ${BASE_COLORS.curiousBlue} !important;
}
.select-parts-modal{
  .ant-table-thead>tr:hover:not(.ant-table-expanded-row)>td {
    background-color: ${BASE_COLORS.curiousBlue} !important;
  }
  .selected-parts-dropdown{
    width: 200px;
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
  .selected-parts-dropdown{
    width: 200px;
  }
}
.create-label-modal{
  float: left;
  left: 20px;
  .ant-modal-body{
    margin-top: 10px;
    height: 550px;
    overflow: auto;
    padding-right: 20px;
  }
}

.add-account-group{
  .select-accounts{
    .ant-select-selector{
      max-height: 90px;
      overflow-y: auto;
    }
  }
  .main-description{
    .ant-descriptions-row >td{
      padding-bottom: 10px !important;
    }
  }
  .view-account-description{
    td.ant-descriptions-item-content{
      .accounts-box{
        max-height: 140px;
        overflow-y: auto;
      }
      p{
        margin-top: 0 !important;
        margin-bottom: 5px !important;
      }
    }
  }
}

.po-notification-modal{
  .ant-modal-title{
    padding-bottom: 10px;
  }
}

.read-only-text {
  font-weight: ${FONT_WEIGHT.normal};
  font-size: ${FONT_SIZE_PX.xs};
  font-family: ${FONT_FAMILY.main};
  letter-spacing: 0px;
  color: ${BASE_COLORS.black};
  opacity: 0.5;
}

.ant-steps .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-title::after {
  background-color: ${BASE_COLORS.curiousBlue};
}

.ant-steps .ant-steps-item-process .ant-steps-item-icon >.ant-steps-icon .ant-steps-icon-dot {
  background: ${BASE_COLORS.downRiver};
}

.ant-steps .ant-steps-item-finish .ant-steps-item-icon >.ant-steps-icon .ant-steps-icon-dot {
  background: ${BASE_COLORS.downRiver};
}

.ant-steps .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-tail::after {
  background-color: ${BASE_COLORS.downRiver};
  height: 1.5px;
}

.ant-steps.ant-steps-dot.ant-steps-small .ant-steps-item-tail::after {
  height: 1.5px;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  background: ${BASE_COLORS.downRiver} !important;
  border-color: ${BASE_COLORS.downRiver} !important;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
  background-color: ${BASE_COLORS.downRiver} !important;
}

.ant-drawer .ant-drawer-body {
  padding: 12px;
}

.add-facility-modal{
  .ant-modal-content {
    padding: 10px;
    overflow: auto;
  }

  .ant-modal-body {
    max-height: calc(100vh - 240px);
    overflow: auto;
  }
  
  .ant-modal-close {
    top: "18px";
  }

  .ant-modal-header {
    border-bottom: 1.5px solid rgba(5,5,5,.06);
    margin-bottom: 0px;
  }

  .ant-modal-title {
    line-height: 2;
    padding-bottom: 2px;
  }

  .ant-form-item {
    margin-bottom: 10px;
  }

  .ant-form-item-label>label {
    min-width: 171px;
    justify-content: "flex-end";
    margin-right: 5px;
  }

  .ant-tooltip {
    display: none;
  }

  .ant-modal-body {
    font-size: ${FONT_SIZE_PX.xs};
    line-height: 1;
  }

  .ant-modal-footer {
    margin-top: 0 !important;
  }

  .ant-form {
    font-family: ${FONT_FAMILY.main};
  }

  [class*=" ant-row"] {
    font-family: ${FONT_FAMILY.main};
    font-size: ${FONT_SIZE_PX.xs};
  }
}

.read-only-field .ant-input,
.read-only-field .ant-input:hover,
.read-only-field .ant-input:focus,
.read-only-field .ant-input:focus-within {
  border-color: ${BASE_COLORS.transparent};
}

.update-cost-drawer{
  .ant-drawer-header-title{
    flex-direction: row-reverse !important;
  }
  .ant-form-item{
    margin-bottom: 0;
  }
  .ant-table-wrapper .ant-table.ant-table-small .ant-table-tbody>tr>td:last-child{
    text-align: left;
  }
}
.submit-invoice-drawer{
  .ant-drawer-header-title{
    flex-direction: row-reverse !important;
  }
  thead.ant-table-thead {
    tr:hover {
      background-color: ${BASE_COLORS.curiousBlue} !important;
    }
  }
  .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td {
    background-color: rgb(34, 128, 190) !important;

  }
  .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td:before{
    display: none;
  }
  .ant-table-thead > tr:not(.ant-table-expanded-row) > td:before{
    display: none;
  }
}

.submit-invoice-modal{
  .ant-form-item{
    margin-bottom: 0 !important;
  }
}

.add-pod-modal{
  .read-only-input-waybill{
    border: none !important;
  }
  .ant-modal-title{
    margin-bottom: 10px;
  }
  .ant-form-item-label{
    margin-right: 5px;
  }
}

.vessel-vissibility-modal{
  .ant-descriptions-item-label{
    width: 40%;
  }
  .ant-descriptions-item-content{
    width: 60%;
  }
}

.ant-input-textarea-show-count{
  border: none;
  textarea {
    border-radius: 8px !important;
  }
}

.add-user-modal {
  .ant-modal-content {
    padding: 10px;
    width: 500px;
  }

  .ant-modal-body {
    max-height: calc(100vh - 240px);
    overflow: auto;
  }
  .ant-modal-header {
    border-bottom: 1.5px solid rgba(5,5,5,.06);
    padding: 5px;
  }
}
.account-settings-modal {
  .ant-modal-content {
    padding: 10px;
    overflow: auto;
    width: 550px;
  }

  .ant-modal-body {
    max-height: calc(100vh - 240px);
    overflow: auto;
  }
  .ant-modal-header {
    border-bottom: 1.5px solid rgba(5,5,5,.06);
    padding: 5px;
  }
}

.edit-user-modal {
  .ant-modal-content {
    padding: 10px;
    overflow: auto;
    height: 465px;
    width: 500px;
  }
  .ant-modal-body {
    height: 350px;
  }
  .ant-modal-header {
    border-bottom: 1.5px solid rgba(5,5,5,.06);
    padding: 5px;
  }
}

.add-user-drawer{
  font-family: "Poppins" !important;
  .ant-drawer-header-title{
    flex-direction: row-reverse;
  }
  .ant-drawer-body{
    padding: 16px 24px;
  }
  .ant-tabs-tab-btn{
    font-size: 14px;
    font-family: "Poppins" !important;
  }
}

.add-pdf-modal-invalid{
  .ant-modal-header .ant-modal-title{
    padding: 5px 10px 10px 10px;
    border-bottom: 1.5px solid rgba(5,5,5,.06);
  }
  .ant-modal-content {
    padding: 10px 10px 20px 10px;
    max-height: calc(100vh - 10vh);
    overflow-x: hidden;
    overflow-y: hidden;
    width: 700px;
    min-height:73vh;
  }
}

.add-pdf-modal-invoice > div{
  width: 100%;
  .ant-modal-header .ant-modal-title{
    padding: 5px 10px 10px 10px;
    border-bottom: 1.5px solid rgba(5,5,5,.06);
  }
}
.add-pdf-modal-invoice{
  .ant-modal-content {
    padding: 10px 10px 20px 10px;
    max-height: calc(100vh - 20vh);
    overflow-x: hidden;
    overflow-y: hidden;
    min-height:75vh;
  }
}
  .ant-descriptions-item-label{
    padding: 5px 15px !important;
    font-family: "Poppins" !important;
  }
  .ant-descriptions-item-content{
    padding: 5px 15px !important;
    font-family: "Poppins" !important;
    p{
      margin-top: 0;
    }
  }
  .line-item-header-row{
    background-color: ${BASE_COLORS.curiousBlue};
    padding: 10px 2px;
    color: #FFF;
    margin: 0 !important;
    .ant-col-8:not(:last-child){
      border-right: 1px solid;
    }
    .ant-col-9:not(:last-child){
      border-right: 1px solid;
    }
    .ant-col-6:not(:last-child){
      border-right: 1px solid;
    }
}

.ant-collapse-header-text{
  font-family: "Poppins" !important;
}
`;

export default GlobalStyles;
